import { Grid, TableCell } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DescriptionIcon from "@material-ui/icons/Description";
import EditIcon from "@material-ui/icons/Edit";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { ITableColumn } from "components/interfaces";
import { useState } from "react";
import { FileCheckedIcon } from "../../../assets/icons/CustomSVGIcons";
import { MeasurementStore } from "../../../store";
import { ActionButton, CollapsibleRow } from "../../UI/Table";
import { DetailsTable } from "./DetailsTable";
import { StatusSelect } from "./TableStickers";

import { lang } from "../../../i18nLang";
const label = "measurements.table";

const Actions = ({
  open,
  onClickCollapse,
  onClickEdit,
  onClickEditBilling,
  onClickShowBilling,
  onClickAttachFiles,
  disableEditingBilling = false,
  disableShowingBilling = false,
}) => (
  <TableCell>
    <ActionButton
      title={lang("expand")}
      ariaLabel="expand row"
      onClick={onClickCollapse}
    >
      {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </ActionButton>
    <ActionButton
      title={lang(disableEditingBilling ? "view" : "edit")}
      ariaLabel={disableEditingBilling ? "view" : "edit"}
      onClick={onClickEdit}
    >
      {disableEditingBilling ? <FileCheckedIcon /> : <EditIcon />}
    </ActionButton>
    {!disableEditingBilling && (
      <ActionButton
        title={lang(`${label}.buttonBilling`)}
        ariaLabel="billing"
        onClick={onClickEditBilling}
      >
        <ReceiptIcon htmlColor={grey[600]} />
      </ActionButton>
    )}
    {disableEditingBilling && (
      <ActionButton
        title={"Visualizar dados da integração"}
        ariaLabel="billing"
        onClick={onClickShowBilling}
      >
        <DescriptionIcon
          htmlColor={disableShowingBilling ? grey[400] : grey[600]}
        />
      </ActionButton>
    )}
    <ActionButton
      title={lang("attachments.attachFiles")}
      ariaLabel="Ver anexos da medição"
      onClick={onClickAttachFiles}
      style={{ transform: "rotate(40deg)" }}
    >
      <AttachFileIcon htmlColor={grey[600]} />
    </ActionButton>
  </TableCell>
);

interface IProps {
  row: any;
  columns: ITableColumn[];
  onEdit: Function;
  onSendToBilling: (uid: string) => void;
  onShowBilling: (uid: string) => void;
  onAttachFiles: (uid: string) => void;
  onChangeStatus: (uid: string, status) => void;
  onChangePeriod: (uid: string, initialDate: Date, finalDate: Date) => void;
  onExpandDetails: (uid: string) => void;
}

const MeasurementRow = ({
  row,
  columns,
  onEdit,
  onSendToBilling,
  onShowBilling,
  onAttachFiles,
  onChangeStatus,
  onChangePeriod,
  onExpandDetails,
}: IProps) => {
  const [open, setOpen] = useState(false);
  const subColumns: ITableColumn[] = [
    {
      dataKey: "details",
      label: "",
      padding: "none",
    },
  ];

  const handleClickCollapse = () => {
    if (!open) onExpandDetails(row.uid);
    setOpen(!open);
  };

  const handleClickEdit = () => {
    onEdit(row.uid);
  };

  const handleClickEditBilling = () => {
    onSendToBilling(row.uid);
  };

  const handleClickShowBilling = () => {
    onShowBilling(row.uid);
  };

  const handleChangeStatus = (ev) => {
    onChangeStatus(row.uid, ev.target.value);
  };

  const handleClickAttachFiles = () => {
    onAttachFiles(row.uid);
  };

  const newRow: any = {
    ...row,
    status: (
      <StatusSelect
        value={row.status}
        onChange={handleChangeStatus}
        options={MeasurementStore.getStatusValues()}
      />
    ),
  };

  const details = (
    <Grid container>
      <Grid container item direction="row" xs={12}>
        <DetailsTable row={row} onChangePeriod={onChangePeriod} />
      </Grid>
    </Grid>
  );

  return (
    <CollapsibleRow
      open={open}
      columns={columns}
      subColumns={subColumns}
      row={newRow}
      rowDetails={[{ details }]}
      actionCell={
        <Actions
          open={open}
          onClickCollapse={handleClickCollapse}
          onClickEdit={handleClickEdit}
          onClickEditBilling={handleClickEditBilling}
          onClickShowBilling={handleClickShowBilling}
          onClickAttachFiles={handleClickAttachFiles}
          disableEditingBilling={row.disableEditBilling}
          disableShowingBilling={row.disableShowBilling}
        />
      }
      subColumnLength={columns.length + 1}
      blankColumns={0}
    />
  );
};

export default MeasurementRow;
